import { render, staticRenderFns } from "./PersonaInformationForm.vue?vue&type=template&id=37261d26"
import script from "./PersonaInformationForm.vue?vue&type=script&lang=js"
export * from "./PersonaInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports